import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty, get, head, find } from 'lodash'
import CurrencyFormat from 'react-currency-format'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { isMobile } from 'react-device-detect'
import { connect } from 'react-redux'
import Countdown from 'react-countdown'
import {
    Container,
    Card,
    CardBody,
    CardFooter,
    Row,
    Col,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from 'reactstrap'
import { useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js'
import { Link } from 'react-router-dom'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'
import { getClassOrderStatus } from '../../../helpers/utils'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'
import orderEnvioImg from '../../../assets/images/orders/envio.png'
import PaymentModal from '../../../components/Common/PaymentModal'

const routeSuppliersStorage = 'suppliers/'

moment.locale('es')
const LIMIT = 1000

const OrdersDatatable = (props) => {
    const stripe = useStripe()
    const elements = useElements()

    const generalContext = useContext(GeneralContext)
    const { loading, setLoading } = generalContext

    const [list, setList] = useState([])
    const [offset, setOffset] = useState(0) // eslint-disable-line
    const [totalCount, setTotalCount] = useState(0) // eslint-disable-line
    const [filter, setFilter] = useState([]) // eslint-disable-line
    const [userAddressCount, setUserAddressCount] = useState(-1)
    const [orderConfirmedModal, setOrderConfirmedModal] = useState(false)
    const [orderConfirmed, setOrderConfirmed] = useState({})
    const [settings, setSettings] = useState({})
    const [paymentMethods, setPaymentMethods] = useState([])
    const [orderExpirationTime, setOrderExpirationTime] = useState([])
    const [orderTemporal, setOrderTemporal] = useState({})
    const [deleteOrderModal, setDeleteOrderModal] = useState(false)
    const [cardHolderName, setCardHolderName] = useState('')
    const [clientSecret, setClientSecret] = useState('')
    const [orderSelected, setOrderSelected] = useState({})

    const toggleOrderConfirmedModal = () => setOrderConfirmedModal(!orderConfirmedModal)
    const toggleDeleteOrderModal = () => setDeleteOrderModal(!deleteOrderModal)

    const [payModal, setPayModal] = useState(false)
    const togglePayModal = () => setPayModal(!payModal)

    const fetchData = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getOrdersByUser(offset, LIMIT, filter)
            setTotalCount(response.data.count)
            setUserAddressCount(response.data.userAddressCount)
            setSettings(response.data.settings)
            setPaymentMethods(response.data.paymentMethods)
            setOrderExpirationTime(response.data.ordersExpirationTime)
            setList(response.data.data)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            toastr.error(`${e.response.data.message}`, 'Error')
        }
    }

    useEffect(() => {
        (async function fetch() {
            await fetchData()
        })()
    }, [offset, filter]) // eslint-disable-line

    const goToDetailOfOrder = (item) => {
        window.analytics.track(`View order detail`, { order: item.id })
        setOrderConfirmed(item)
        toggleOrderConfirmedModal()
    }

    const editOrder = (item) => {
        window.analytics.track(`Go to Edit Order`, { order: item.id })
        props.history.push(`/pedidos/editar/${item.id}`)
    }

    const removeOrder = async (item) => {
        setOrderTemporal(item)
        toggleDeleteOrderModal()
    }

    const confirmRemoveOrder = async () => {
        setLoading(true)
        toggleDeleteOrderModal()
        const response = await ApiService.deleteOrder(orderTemporal.id).catch(error => {
            toastr.error(`No pude eliminar el pedido ${error}`, 'Error')
            return
        })
        if (!isEmpty(response.data)) {
            if (response.data.success) {
                toastr.success(`El pedido fue eliminado.`, '¡Éxito!')
                await fetchData()
                setOrderTemporal({})
                window.analytics.track(`Order Deleted`, { order: orderTemporal.id })
            }
        }
    }

    const openPaymentModal = async (item) => {
        setOrderSelected(item)
        // Crear intento de pago
        setLoading(true)
        const paymentIntent = await ApiService.createIntentOfPayment({ orderId: item.id })
        setClientSecret(paymentIntent.data.client_secret)
        togglePayModal()
        setLoading(false)
    }

    const payOrder = async () => {
        if (!stripe || !elements) {
            console.log('stripe js not loaded yet')
            toastr.error(`stripe js not loaded yet`, 'Error')
            return
        }
        try {
            togglePayModal()
            setLoading(true)
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        name: cardHolderName,
                    },
                }
            })
            if (result.error) {
                toastr.error(`${result.error.message}`, 'Error')
                return
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    // Actualizar orden a pagado
                    const orderUpdated =
                        await ApiService.markeOrderAsPaid({
                            orderId: orderSelected.id,
                            paymentIntentId: result.paymentIntent.id,
                            cardHolderName,
                            cartId: orderSelected.cartId,
                            couponReleasedId: orderSelected.couponReleasedId,
                        })
                    if (orderUpdated.data.success) {
                        setOrderConfirmed(orderUpdated.data.order)
                        toggleOrderConfirmedModal()
                        await fetchData()
                    }
                }
            }
        } catch (e) {
            console.log('error in pay order')
            console.log(e)
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            {userAddressCount > 0 && !isEmpty(list) && list.map((item, key) => (
                <Card key={`grid_${key}`}>
                    <CardBody>
                        <Row>
                            <Col sm={isMobile ? '5' : '4'}>
                                {!isMobile && (
                                    <div style={{ display: 'inline-flex', minHeight: '1px' }}>
                                        <div style={{ marginTop: '20px' }}>
                                            <img
                                                src={
                                                    !isEmpty(item.supplier.logotipo)
                                                        ? `${ApiService.getUrlBaseStorage()}${routeSuppliersStorage}${item.supplier.logotipo}`
                                                        : getUrlOfDefaultProductImage()
                                                }
                                                alt=""
                                                width="70px"
                                                height="50px"
                                                style={{ marginBottom: '5px' }}
                                                className="img-fluid mx-auto"
                                            />
                                        </div>
                                        <div
                                            className="d-block"
                                            style={{ marginLeft: !isMobile ? '10px' : '0px' }}
                                        >
                                            <div style={{ fontWeight: '600' }}>{item.supplier.nombreComercial}</div>
                                            <span style={{ color: 'gray' }}>
                                                {moment(item.createdAt, 'YYYY-MM-DD').format('DD MMMM YYYY')}
                                            </span>
                                            <div style={{ marginTop: isMobile ? '5px' : '0px' }}>Folio del pedido: <label>{item.folio}</label></div>
                                        </div>
                                    </div>
                                )}
                                {isMobile && (
                                    <Row>
                                        <Col
                                            className="text-left"
                                            style={{ marginLeft: isMobile ? '0px' : '0px', marginTop: isMobile ? '3px' : '3px' }}
                                        >
                                            <div>
                                                <span style={{ fontWeight: '600' }}>{item.supplier.nombreComercial}</span><br />
                                                <span style={{ color: 'gray' }}>
                                                    {moment(item.createdAt, 'YYYY-MM-DD').format('DD MMMM YYYY')}
                                                </span><br />
                                                <span style={{ marginTop: isMobile ? '5px' : '0px' }}>Folio del pedido: <label>{item.folio}</label></span>
                                            </div>
                                        </Col>
                                        <Col className="text-right font-size-20">
                                            <img
                                                src={
                                                    !isEmpty(item.supplier.logotipo)
                                                        ? `${ApiService.getUrlBaseStorage()}${routeSuppliersStorage}${item.supplier.logotipo}`
                                                        : getUrlOfDefaultProductImage()
                                                }
                                                alt=""
                                                width="70px"
                                                height="50px"
                                                style={{ marginBottom: '5px' }}
                                                className="img-fluid mx-auto"
                                            />
                                        </Col>
                                    </Row>
                                )}
                            </Col>
                            <Col sm="2">
                                <div style={{ marginTop: isMobile ? '0px' : '5px' }}>
                                    Productos: <label>{item.lineItems.length}</label>
                                </div>
                            </Col>
                            <Col sm="5">
                                <Row>
                                    <Col
                                        className={isMobile ? "text-left" : "text-center"}
                                        style={{ marginLeft: isMobile ? '0px' : '0px', marginTop: isMobile ? '3px' : '3px' }}
                                    >
                                        <div
                                            className={getClassOrderStatus(item.status)}
                                            style={{ width: isMobile ? '50px' : '100%', marginRight: isMobile ? '24px' : '0px' }}
                                        >
                                            {get(item, 'status.name', '')}
                                        </div>
                                        {
                                            !isEmpty(orderExpirationTime) && item.status.codeName === 'PENDIENTE_DE_PAGO' ? (
                                                <div className="text-center">
                                                    <Countdown
                                                        date={
                                                            moment(
                                                                item.updatedAt,
                                                                'YYYY-MM-DDTHH:mm:ss.ZZZ'
                                                            )
                                                                .add(
                                                                    find(orderExpirationTime, { codeName: 'ORDER_PAYMENT_PENDING_EXPIRED_TIME' }).value, 'hours'
                                                                ).format()
                                                        }
                                                    />
                                                </div>
                                            ) : null
                                        }
                                        {
                                            !isEmpty(orderExpirationTime) && item.status.codeName === 'BORRADOR' ? (
                                                <div className="text-center">
                                                    <Countdown
                                                        date={
                                                            moment(
                                                                item.updatedAt,
                                                                'YYYY-MM-DDTHH:mm:ss.ZZZ'
                                                            )
                                                                .add(
                                                                    find(orderExpirationTime, { codeName: 'ORDER_DRAFT_EXPIRED_TIME' }).value, 'hours'
                                                                ).format()
                                                        }
                                                    />
                                                </div>
                                            ) : null
                                        }
                                    </Col>
                                    <Col className="text-right font-size-20">
                                        <CurrencyFormat
                                            value={item.total - item.discount}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="$"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            {!isMobile && (
                                <Col sm="1">
                                    <UncontrolledDropdown>
                                        <DropdownToggle href="#" className="card-drop cursor-pointer" tag="i">
                                            <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {
                                                item.status.codeName !== 'BORRADOR' ? (
                                                    <DropdownItem onClick={() => goToDetailOfOrder(item)}>
                                                        <i className="mdi mdi-account-details font-size-16 text-success mr-2"></i> Ver detalle
                                                    </DropdownItem>
                                                ) : null
                                            }
                                            {
                                                item.status.codeName === 'PENDIENTE_DE_PAGO' && (
                                                    <DropdownItem onClick={() => openPaymentModal(item)}>
                                                        <i className="mdi mdi-credit-card font-size-16 text-success mr-2"></i> Pagar con tarjeta
                                                    </DropdownItem>
                                                )
                                            }
                                            {item.status.codeName === 'BORRADOR' || item.status.codeName === 'PENDIENTE_DE_PAGO' ? (
                                                <DropdownItem onClick={() => editOrder(item)}>
                                                    <i className="mdi mdi-pencil font-size-16 text-success mr-2"></i> Editar
                                                </DropdownItem>
                                            ) : null}
                                            {
                                                item.status.codeName === 'BORRADOR' ||
                                                    item.status.codeName === 'PENDIENTE_DE_PAGO' ||
                                                    item.status.codeName === 'CANCELADO' ? (
                                                        <DropdownItem onClick={() => removeOrder(item)}>
                                                            <i className="mdi mdi-trash-can font-size-16 text-danger mr-2"></i> Eliminar
                                                    </DropdownItem>
                                                    ) : null
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </Col>
                            )}
                        </Row>
                    </CardBody>
                    {isMobile && (
                        <CardFooter
                            className="bg-transparent border-top"
                            style={{ textAlign: 'center' }}
                        >
                            <div className="d-flex">
                                <div className="flex-fill">
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 m-0 d-inline align-baseline"
                                        onClick={() => goToDetailOfOrder(item)}
                                        style={{ color: 'black' }}
                                    >
                                        <i className="mdi mdi-account-details font-size-16 text-success mr-2"></i> Ver detalle
                                    </button>
                                </div>
                                {item.status.codeName === 'PENDIENTE_DE_PAGO' && (
                                    <div className="flex-fill">
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 m-0 d-inline align-baseline"
                                            onClick={() => openPaymentModal(item)}
                                            style={{ color: 'black' }}
                                        >
                                            <i className="mdi mdi-credit-card font-size-16 text-success mr-2"></i> Pagar con tarjeta
                                        </button>
                                    </div>
                                )}
                                {item.status.codeName === 'BORRADOR' || item.status.codeName === 'PENDIENTE_DE_PAGO' ? (
                                    <div className="flex-fill">
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 m-0 d-inline align-baseline"
                                            onClick={() => editOrder(item)}
                                            style={{ color: 'black' }}
                                        >
                                            <i className="mdi mdi-pencil font-size-16 text-success mr-2"></i> Editar
                                        </button>
                                    </div>
                                ) : null}
                                {
                                    item.status.codeName === 'BORRADOR' ||
                                        item.status.codeName === 'PENDIENTE_DE_PAGO' ||
                                        item.status.codeName === 'CANCELADO' ? (
                                            <div className="flex-fill">
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 m-0 d-inline align-baseline"
                                                    onClick={() => removeOrder(item)}
                                                >
                                                    <i className="mdi mdi-trash-can font-size-16 text-danger mr-2"></i> Eliminar
                                            </button>
                                            </div>
                                        ) : null
                                }
                            </div>
                        </CardFooter>
                    )}
                </Card>
            ))}
            {userAddressCount > 0 && !isEmpty(list) && (
                <div className="mb-3">
                    <Link
                        onClick={() => {
                            window.analytics.track(`Go to returns page`)
                        }}
                        to={`/devoluciones`}
                        className="btn link-devoluciones">
                        ¿Deseas hacer una devolución?
                    </Link>
                </div>
            )}
            {!loading && userAddressCount === 0 && (
                <React.Fragment>
                    <Card>
                        <CardBody>
                            Para realizar tu primer venta como Vendora, primero debes configurar al menos una dirección de envío.
                            <br /><br />
                            <Link to={`/direcciones-envio/agregar`} className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2">
                                <i className="mdi mdi-plus mr-1"></i> Crear dirección de envío
                            </Link>
                        </CardBody>
                    </Card>
                </React.Fragment>
            )}
            {!loading && isEmpty(list) && userAddressCount > 0 && (
                <React.Fragment>
                    <Card>
                        <CardBody>
                            Es momento de realizar tu primer venta. ¿Estás lista?
                            Comienza explorando los productos que tenemos disponibles para tí, compártelos con tus clientes y echa a volar la imaginación para que cierres tu primer venta.
                            <br /><br />
                            <Link to={`/discovery`} className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2">
                                <i className="mdi mdi-plus mr-1"></i> Explorar Productos
                            </Link>
                        </CardBody>
                    </Card>
                </React.Fragment>
            )}
            <div>
                <Modal isOpen={deleteOrderModal} toggle={toggleDeleteOrderModal}>
                    <ModalHeader toggle={toggleDeleteOrderModal}>Eliminar pedido</ModalHeader>
                    <ModalBody>
                        ¿Está seguro que desea eliminar el pedido?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleDeleteOrderModal}>Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={confirmRemoveOrder}>Confirmar</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={orderConfirmedModal} toggle={toggleOrderConfirmedModal}>
                    <ModalHeader toggle={toggleOrderConfirmedModal}>Detalles de tu pedido folio: {orderConfirmed.folio}</ModalHeader>
                    <ModalBody>
                        <Container>
                            <Row>
                                <Col className="text-center">
                                    <span
                                        style={{ fontSize: '16px' }}
                                        className={!isEmpty(orderConfirmed) ? getClassOrderStatus(orderConfirmed.status) : ''}
                                    >
                                        {get(orderConfirmed, 'status.name', '')}
                                    </span>
                                </Col>
                            </Row>
                            <Card>
                                <CardBody>
                                    <div>
                                        <label className="font-weight-bold">
                                            Fecha de compra:
                                        </label>
                                        <div>
                                            {
                                                !isEmpty(orderConfirmed) ?
                                                    ` ${moment(orderConfirmed.createdAt, 'YYYY-MM-DD').format('DD MMMM YYYY')}`
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </div>
                                    {
                                        !isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PENDIENTE_DE_PAGO' && (
                                            <span>
                                                <div style={{ marginTop: '10px' }}>
                                                    <label className="font-weight-bold">Fecha limite de pago: </label>
                                                    <p>{moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').add(1, 'day').format('DD MMMM YYYY hh:mm A')}</p>
                                                </div>
                                                <p style={{ marginBottom: '5px' }}>
                                                    Recuerda que tienes 24 horas para hacer tu pago.
                                                </p>
                                                {
                                                     orderConfirmed.paymentType === 'bank' && !isEmpty(paymentMethods) && paymentMethods.map(pay => (
                                                        <div key={`pay_${pay.id}`}>
                                                            <div>
                                                                <label className="font-weight-bold">
                                                                    Método de pago: 
                                                                </label> {' '}
                                                                <label className="font-weight-bold" style={{ color: 'green' }}>
                                                                    {pay.name}
                                                                </label>
                                                            </div>
                                                            <div>
                                                                {pay.accountPrefix}
                                                            </div>
                                                            <div>
                                                                {pay.accountNumber}
                                                            </div>
                                                            <div>
                                                                {pay.entityName}
                                                            </div>
                                                            <div style={{ marginBottom: '10px' }}>
                                                                {pay.ownerName}
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    orderConfirmed.paymentType === 'oxxo' && (
                                                        <div>
                                                            <div style={{ marginTop: '10px' }}>
                                                                <div>
                                                                    <label className="font-weight-bold">
                                                                        Método de pago:
                                                                    </label> {' '}
                                                                    <label className="font-weight-bold" style={{ color: 'green' }}>
                                                                        Oxxo
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label className="font-weight-bold">
                                                                        Monto a pagar:
                                                                    </label> {' '}
                                                                    <label style={{ fontSize: '18px' }}>
                                                                        <CurrencyFormat
                                                                            value={orderConfirmed.total}
                                                                            displayType="text"
                                                                            thousandSeparator
                                                                            prefix="$"
                                                                        />
                                                                        <sup>MXN</sup>
                                                                    </label>
                                                                    <div style={{ fontSize: '10px' }}>
                                                                        <p>OXXO cobrará una comisión adicional al momento de realizar el pago.</p>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <label className="font-weight-bold">Referencia</label>
                                                                    <h4
                                                                        style={{
                                                                            color: '#000000',
                                                                            textAlign: 'center',
                                                                            marginTop: '-1px',
                                                                            padding: '6px 0 7px',
                                                                            border: '1px solid #b0afb5',
                                                                            borderRadius: '4px',
                                                                            background: '#f8f9fa',
                                                                        }}
                                                                    >
                                                                        {orderConfirmed.oxxoReference}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="font-weight-bold">Instrucciones</label>
                                                                    <ol>
                                                                        <li style={{ marginTop: '10px', color: '#000000' }}>Acude a la tienda OXXO más cercana. <a style={{ color: '#1155cc' }} href="https://www.google.com.mx/maps/search/oxxo/" target="_blank" rel="noopener noreferrer">Encuéntrala aquí</a>.</li>
                                                                        <li style={{ marginTop: '10px', color: '#000000' }}>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li>
                                                                        <li style={{ marginTop: '10px', color: '#000000' }}>Dicta al cajero el número de referencia en esta ficha para que tecleé directamete en la pantalla de venta.</li>
                                                                        <li style={{ marginTop: '10px', color: '#000000' }}>Realiza el pago correspondiente con dinero en efectivo.</li>
                                                                        <li style={{ marginTop: '10px', color: '#000000' }}>Al confirmar tu pago, el cajero te entregará un comprobante impreso. <strong>En el podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de pago.</li>
                                                                    </ol>
                                                                <div className="opps-footnote">Al completar estos pasos recibirás un correo de <strong>Vendora</strong> confirmando tu pago.</div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </span>
                                        )
                                    }
                                    {
                                        orderConfirmed.paymentType !== 'oxxo' && (
                                            <div style={{ marginTop: '10px' }}>
                                                {!isEmpty(orderConfirmed) &&
                                                    (orderConfirmed.status.codeName === 'PENDIENTE_DE_PAGO' ||
                                                        orderConfirmed.status.codeName === 'PENDIENTE_DE_PAGO_TARJETA' ||
                                                        orderConfirmed.status.codeName === 'EN_PROCESO_DE_PAGO') ? 'Monto a pagar: ' : 'Total con envío: '}
                                                <label style={{ fontSize: '18px' }}>
                                                    <CurrencyFormat
                                                        value={orderConfirmed.total - orderConfirmed.discount}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="$"
                                                    />
                                                    <sup>MXN</sup>
                                                </label>
                                            </div>
                                        )
                                    }
                                    {!isEmpty(orderConfirmed) && (orderConfirmed.status.codeName !== 'PENDIENTE_DE_PAGO') && (
                                        <div style={{ marginTop: '10px' }}>
                                            <label className="font-weight-bold">
                                                Método de pago:
                                            </label> {' '}
                                            <label className="font-weight-bold" style={{ color: 'green' }}>
                                                {orderConfirmed.paymentType === 'card' && (<div> Pago en línea</div>)}
                                                {orderConfirmed.paymentType === 'bank' && (<div> Transferencia / Depósito</div>)}
                                                {orderConfirmed.paymentType === 'oxxo' && (<div> Oxxo</div>)}
                                            </label>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <img
                                        src={orderEnvioImg}
                                        alt="Dirección de envío"
                                        className="img-fluid mx-auto d-block"
                                        width="240px"
                                        height="111px"
                                        style={{ marginBottom: '20px' }}
                                    />
                                    <div
                                        className="font-weight-bold"
                                        style={{ marginBottom: '20px' }}
                                    >
                                        <label style={{ fontSize: '16px', color: '#e52e6a' }}>DIRECCIÓN DE ENVÍO</label>
                                    </div>
                                    <div>
                                        <label className="font-weight-bold">{props.user.firstName} {props.user.lastName}</label>
                                    </div>
                                    <div style={{ fontSize: '12px', marginBottom: '10px' }}>
                                        {!isEmpty(orderConfirmed) && (`
                                            ${orderConfirmed.userAddress.calle} 
                                            ${orderConfirmed.userAddress.numeroExterior} 
                                            ${orderConfirmed.userAddress.numeroInterior} 
                                            ${orderConfirmed.userAddress.colonia} 
                                            ${orderConfirmed.userAddress.cp} 
                                            ${orderConfirmed.userAddress.entreCalles} 
                                            ${orderConfirmed.userAddress.localidad} 
                                            ${orderConfirmed.userAddress.municipio} 
                                            ${orderConfirmed.userAddress.state.nomEstado} 
                                            ${orderConfirmed.userAddress.country.nameEn}
                                        `)}
                                    </div>
                                    <div style={{ marginTop: '20px' }}>
                                        {orderConfirmed.paqueteria && (
                                            <div>
                                                Paqueteria: <label className="font-weight-bold">{orderConfirmed.paqueteria}</label>
                                            </div>
                                        )}
                                        {orderConfirmed.guiaRastreo && (
                                            <div>
                                                Guía de rastreo: <label className="font-weight-bold">{orderConfirmed.guiaRastreo}</label>
                                            </div>
                                        )}
                                        {orderConfirmed && orderConfirmed.supplier && (
                                            <div>
                                                Fecha estimada de entrega: <label className="font-weight-bold">{moment(orderConfirmed.createdAt, 'YYYY-MM-DD').add(orderConfirmed.supplier.tiempoEntregaEstandar, 'days').format('DD MMMM YYYY')}</label>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        La dirección no podrá ser modificada, cualquier aclaración al correo <a href={`mailto:${settings ? settings.value : ''}`}>{settings ? settings.value : ''}</a>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <div
                                        className="font-weight-bold"
                                        style={{ marginBottom: '10px' }}
                                    >
                                        <label
                                            style={{ fontSize: '16px', color: '#e52e6a' }}
                                        >
                                            {!isEmpty(orderConfirmed) ? orderConfirmed.supplier.razonSocial : ''}
                                        </label>
                                    </div>
                                    <div style={{ marginBottom: '10px' }}>
                                        Fecha de recepción:
                                    </div>
                                    <div style={{ marginBottom: '10px' }}>
                                        <label className="font-weight-bold">
                                            {
                                                !isEmpty(orderConfirmed) ?
                                                    moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm').format('DD MMMM YYYY hh:mm A')
                                                    :
                                                    ''
                                            }
                                        </label>
                                    </div>
                                    <div className="text-center">
                                        {
                                            !isEmpty(orderConfirmed) && orderConfirmed.lineItems.map(item => (
                                                <div key={`detail_${item.id}`}>
                                                    <div
                                                        className="product-image-order-confirmed"
                                                        style={{ marginBottom: '150px' }}
                                                    >
                                                        <img
                                                            src={!isEmpty(item.product.gallery) ? head(item.product.gallery).fileName : getUrlOfDefaultProductImage()}
                                                            alt={item.product.name}
                                                            className="img-fluid mx-auto d-block"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="font-weight-bold" style={{ marginTop: '25px' }}>{item.product.name}</label>
                                                        {!isEmpty(item.productVariant) && (
                                                            <div>
                                                                {!isEmpty(item.productVariant.firstOption.label) && (
                                                                    <span>{item.productVariant.firstOption.label}: <label>{item.productVariant.firstOption.value} </label></span>
                                                                )}
                                                                {!isEmpty(item.productVariant.secondOption.label) && (
                                                                    <span> - {item.productVariant.secondOption.label}: <label>{item.productVariant.secondOption.value} </label></span>
                                                                )}
                                                                {!isEmpty(item.productVariant.thirdOption.label) && (
                                                                    <span> - {item.productVariant.thirdOption.label}: <label>{item.productVariant.thirdOption.value}</label></span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        Cantidad: <label className="font-weight-bold">{item.quantity}</label> -
                                                        Importe: <label className="font-weight-bold">
                                                            <CurrencyFormat
                                                                value={` ${item.subtotal}`}
                                                                displayType="text"
                                                                thousandSeparator
                                                                prefix="$"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <div className="text-right">
                                        <div style={{ marginBottom: '10px' }}>
                                            Productos: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={!isEmpty(orderConfirmed) ? orderConfirmed.subtotal : ''}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '10px' }}>
                                            Envío: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={!isEmpty(orderConfirmed) ? orderConfirmed.deliveryCost : ''}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '10px' }}>
                                            Subtotal: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={orderConfirmed.total}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '10px' }}>
                                            Descuento: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={orderConfirmed.discount}
                                                    displayType="text"
                                                    renderText={value => (<div>- {value}</div>)}
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '20px' }}>
                                            Total a pagar: {' '}
                                            <label style={{ fontSize: '18px' }}>
                                                <CurrencyFormat
                                                    value={orderConfirmed.total - orderConfirmed.discount}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                                <sup>MXN</sup>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <div style={{ marginBottom: '20px' }}>
                                            ¡Gracias por comprar en <label style={{ color: '#e52e6a' }}>Vendora!</label>
                                        </div>
                                        <div>
                                            Si tienes alguna duda o comentario sobre la transacción favor de enviar un correo a <a href={`mailto:${settings ? settings.value : ''}`}>{settings ? settings.value : ''}</a>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleOrderConfirmedModal}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>

            <PaymentModal
                loading={loading}
                stripe={stripe}
                open={payModal}
                cardHolderName={cardHolderName}
                setCardHolderName={setCardHolderName}
                togglePaymentModal={togglePayModal}
                payOrder={payOrder}
            />
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.Login.user
    }
}

export default connect(mapStatetoProps, {})(withRouter(OrdersDatatable))
